const rankingData = [
  { rank: 1, title: '长安十二时辰', hot: '982万', category: '古装悬疑', tag: '热播中' },
  { rank: 2, title: '隐秘的角落', hot: '876万', category: '悬疑剧情', tag: '高分推荐' },
  { rank: 3, title: '玫瑰的故事', hot: '754万', category: '都市情感', tag: '新剧上线' },
  { rank: 4, title: '庆余年第二季', hot: '689万', category: '古装权谋', tag: '持续更新' },
  { rank: 5, title: '狂飙', hot: '612万', category: '刑侦反腐', tag: '经典重温' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热播榜单</h2>
          <p className="mt-2 text-sm text-foreground-500">实时热度排行，追剧不迷路</p>
        </div>

        <div className="flex flex-col gap-3 max-w-3xl mx-auto">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-50 rounded-xl px-5 py-4 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.category}</p>
              </div>
              <span className="whitespace-nowrap px-2.5 py-1 text-xs rounded-full bg-accent-100 text-accent-700">
                {item.tag}
              </span>
              <span className="whitespace-nowrap text-xs text-foreground-400 font-medium min-w-[60px] text-right">
                <i className="ri-fire-line text-accent-500 mr-1"></i>{item.hot}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}